import 'styles'
import './globalWindowPatches'
import './scrollIntoViewIfNeeded'

import { Provider } from 'react-redux'
import { QueryClientProvider } from 'react-query'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { OverlayContainer } from '@react-aria/overlays'
import { useEffect } from 'react'

import Signup from './screens/Signup/Signup'
import store from './redux/store'
import queryClient from './queryClient'
import { RootStoreProvider } from './stores/RootStore'
import { ThemeProvider } from './components/ThemeProvider/ThemeProvider'
import { SignupTrackingPixels } from 'components/TrackingPixels'
import { AuthChannelProvider } from 'providers/AuthChannelProvider/AuthChannelProvider'
import { GoogleFontsLoader } from 'components/GoogleFontsLoader/GoogleFontsLoader'
import { BlazeFontsLoader } from 'components/BlazeFontsLoader/BlazeFontsLoader'

const SignupRouter = () => {
  const location = useLocation()

  useEffect(() => {
    if (location.pathname !== '/signup') {
      // eslint-disable-next-line no-restricted-properties
      window.location.href = `${location.pathname}${location.search}${location.hash}`
    }
  }, [location.pathname, location.search, location.hash])

  return <Signup />
}

export const SignupRoot = () => {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <RootStoreProvider>
          <BrowserRouter>
            <ThemeProvider />
            <GoogleFontsLoader />
            <BlazeFontsLoader />
            <OverlayContainer>
              <SignupTrackingPixels>
                <AuthChannelProvider>
                  <SignupRouter />
                </AuthChannelProvider>
              </SignupTrackingPixels>
            </OverlayContainer>
          </BrowserRouter>
        </RootStoreProvider>
      </QueryClientProvider>
    </Provider>
  )
}

export default SignupRoot
